import {
  getStudentPointByEventType,
  getStudentTradeList,
  getTradeEvent,
  getEventCanTradeList,
  getStudentPointListByEvent,
  createStudentPointByQRCode,
}
  from '~api/point'

export const state = () => ({
  obtainRecord: [],
  obtainLimit: 0,
  exchangeRecord: [],
  tradeEvents: [],
  eventCanTradeList: [],
  allEventSquadTotal: 0,
  studentPointList: [],
})

export const getters = {
  obtainRecordGetter: state => state.obtainRecord,
  obtainLimitGetter: state => state.obtainLimit,
  exchangeRecordGetter: state => state.exchangeRecord,
  tradeEventsGetter: state => state.tradeEvents,
  eventCanTradeListGetter: state => state.eventCanTradeList,
  allEventSquadTotalGetter: state => state.allEventSquadTotal,
  studentPointListGetter: state => state.studentPointList,
}

export const actions = {
  async getStudentPointByEventType ({
    commit
  }, params) {
    const data = await getStudentPointByEventType(params);
    
    const {
      obtainRecord,
      obtainLimit,
    } = data
    
    commit('setObtainRecord', obtainRecord)
    commit('setObtainLimit', obtainLimit)

    return data
  },
  async getStudentTradeList ({
    commit
  }, params) {
    const data = await getStudentTradeList(params);
    
    const {
      exchangeRecord,
    } = data
    
    commit('setExchangeRecord', exchangeRecord)

    return data
  },
  async getTradeEvent ({
    commit
  }) {
    const data = await getTradeEvent()
    const {
      tradeEvents,
    } = data
    
    commit('setTradeEvents', tradeEvents)

    return data
  },
  async getEventCanTradeList ({
    commit
  }, params) {
    const data = await getEventCanTradeList(params)
    const {
      eventCanTradeList,
    } = data
    
    commit('setEventCanTradeList', eventCanTradeList)

    return data
  },
  async getStudentPointListByEvent ({
    commit
  }, params) {
    const data = await getStudentPointListByEvent(params)
    const {
      allEventSquadTotal,
      studentPointList,
    } = data
    
    commit('setAllEventSquadTotal', allEventSquadTotal)
    commit('setStudentPointList', studentPointList)

    return data
  },
  async createStudentPointByQRCode ({
    commit
  }, params) {
    const data = await createStudentPointByQRCode(params)

    return data
  },
}

export const mutations = {
  setObtainRecord (state, payload) {
    state.obtainRecord = payload
  },
  setObtainLimit (state, payload) {
    state.obtainLimit = payload
  },
  setExchangeRecord (state, payload) {
    state.exchangeRecord = payload
  },
  setTradeEvents (state, payload) {
    state.tradeEvents = payload
  },
  setEventCanTradeList (state, payload) {
    state.eventCanTradeList = payload
  },
  setAllEventSquadTotal (state, payload) {
    state.allEventSquadTotal = payload
  },
  setStudentPointList (state, payload) {
    state.studentPointList = payload
  },
}
